import React, { useEffect, useState } from 'react';
import Box from '@material-ui/core/Box';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch'
import { IBaseProps } from 'app/customers/ExistingCustomerDisplay/types';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Button from '@material-ui/core/Button';
import DisplayExistingCustomer from 'design-v2/common/DisplayExistingCustomer/DisplayExistingCustomerForLegacyDiary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import Typography from '@material-ui/core/Typography';
import { Tooltip } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import style from './style.module.scss';
import classNames from 'classnames';
import typ from 'design-v2/globals/typography.module.css';
import color from 'design-v2/globals/colors/colors.module.css';
import BookedByForNewBooking from 'design-v2/common/BookedBy/LegacyDiary/BookedByForNewBooking';



export default function ExistingCustomerDisplay(props: IBaseProps) {
  const {
    customer,
    setView,
    setBookedbyCustomer,
    bookedbyCustomer,
    setErrors,
    toggleBookedBy,
    isBookedBy,
    country,
    bookedByEnabled,
    triggerBookedByValidation,
    disableEmailSmsNotification,
    toggleEmailSmsNotification,
    titleSubscription
  } = props
  const [expandedCustomer, setExpandedCustomer] = useState<boolean> (true)
  const [expandBookedBy, setExpandBookedBy] = useState<boolean> (false)

  useEffect(() => {
    toggleEmailSmsNotification(isBookedBy)
  }, [isBookedBy])

  return(
    <Box className={style.fullWidth}>
      <Box className={style.customerSearchContainer}>
        <Button onClick={() => setView('SEARCH_CUSTOMER_VIEW')} startIcon={<ArrowBackIcon />} color="primary"> Customer search</Button>
      </Box>
      <Box>
        <div className={style.panelGroup}>
          <div className={style.panel}>
            <div className={style.panelHeaderWithoutTitle} onClick={() => setExpandedCustomer(!expandedCustomer)}>
              <div className={classNames({
                [typ.typSize2]: true,
                [typ.typBold]: true,
                [color.clrNbiMagenta]: true,
              })}>Customer</div>
              <div>{expandedCustomer ? <ExpandMoreIcon /> : <ExpandLessIcon />}</div>
            </div>
            <div style={{ display: !expandedCustomer ? 'none' : 'flex'}}>
              <Box className={style.fullWidth}>
                <DisplayExistingCustomer
                  customer={customer}
                  isBookedBy={isBookedBy}
                  disableEmailSmsNotification={disableEmailSmsNotification}
                  toggleEmailSmsNotification={toggleEmailSmsNotification}
                  titleSubscription={titleSubscription}
                />
              </Box>
            </div>
          </div>
          {bookedByEnabled
            ? <div className={style.panel}>
                <div className={style.panelHeader} onClick={() => setExpandBookedBy(!expandBookedBy)}>
                  <div className={style.header}>
                    <div className={style.buttonTitle}>
                      <FormControlLabel
                        onClick={(event) => event.stopPropagation()}
                        control={<Switch color='primary' checked={isBookedBy} onChange={(event, checked: boolean) => {
                          event.preventDefault();
                          toggleBookedBy(checked)
                          if (checked) {
                            setExpandedCustomer(false)
                            setExpandBookedBy(true)
                          }
                        }} name="isBookedBy" />}
                        label={<Typography className={style.bookedByTitle}>Booked by</Typography>}
                      />
                    </div>
                    <div className={style.infoIcon}>
                      <Tooltip title="This section is for the person/company making the booking if different to the customer details">
                        <InfoIcon />
                      </Tooltip>
                    </div>
                  </div>
                  <div>{expandBookedBy ? <ExpandMoreIcon /> : <ExpandLessIcon />}</div>
                </div>
                <div style={{ display: expandBookedBy && isBookedBy ? 'flex' : 'none'}}>
                  <BookedByForNewBooking
                    titleSubscription={titleSubscription}
                    customer={bookedbyCustomer}
                    handleChange={setBookedbyCustomer}
                    setErrors={setErrors}
                    country={country}
                    triggerBookedByValidation={triggerBookedByValidation}
                    classPrefixBookedBy='ExistingCustomerDisplay'
                  />
                </div>
              </div>
            : null}
        </div>
      </Box>
    </Box>
  )
}
